/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMastek = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.367 18.643c.038-.606.643-.961 1.238-.797.562.155 1.13.116 1.699.144.807.04 1.178.454 1.075 1.25-.083.637-.201 1.268-.245 1.914-.055.814-.672.86-1.312.844h.001c-.612-.078-1.23-.129-1.835-.24-.555-.103-.877-.445-.82-1.049.064-.689.157-1.373.2-2.065zM15.22 6.987c.919-.562 1.8-.38 2.374.504a216.353 216.353 0 0 1 2.57 4.058c.514.832.298 1.85-.537 2.398a131.636 131.636 0 0 1-4.053 2.568c-.943.573-1.821.355-2.431-.593-.88-1.366-1.712-2.764-2.585-4.134-.173-.272-.2-.55-.215-.847h.002c-.01-.665.343-1.119.87-1.453a325.94 325.94 0 0 1 4.005-2.5zM5.911 2.409c.416-.525.97-.504 1.463-.164.752.519 1.456 1.106 2.177 1.668.534.416.545.92.18 1.435-.499.706-1.028 1.39-1.549 2.082-.23.306-.49.565-.915.546-.238.018-.432-.088-.615-.224-.737-.541-1.488-1.063-2.203-1.63-.496-.394-.593-.932-.23-1.457A44.47 44.47 0 0 1 5.91 2.41z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMastek as Mastek };
